import OtAddEditOrganisationCalendar from '@/areas/settings/calendars/ot-add-edit-organisation-calendar.vue';
import OtOrganisationCalendarDetails from '@/areas/settings/calendars/ot-organisation-calendar-details.vue';
import OtSettingsCalendarIndex from '@/areas/settings/calendars/ot-settings-calendar-index.vue';
import OtOrganisationDocumentLayout from '@/areas/settings/documents/ot-organisation-document-layout.vue';
import OtSettingsDocumentsIndex from '@/areas/settings/documents/ot-settings-documents-index.vue';
import OtEditOrganisationUserDetails from '@/areas/settings/organisation-users/ot-edit-organisation-user-details.vue';
import OtOrganisationUserContractsIndex from '@/areas/settings/organisation-users/ot-organisation-user-contracts-index.vue';
import OtOrganisationUserDetails from '@/areas/settings/organisation-users/ot-organisation-user-details.vue';
import OtOrganisationUserLayout from '@/areas/settings/organisation-users/ot-organisation-user-layout.vue';
import OtOrganisationUserProjectsIndex from '@/areas/settings/organisation-users/ot-organisation-user-projects-index.vue';
import OtSettingsUsersIndex from '@/areas/settings/organisation-users/ot-settings-users-index.vue';
import OtEditOrganisationDetails from '@/areas/settings/organisations/ot-edit-organisation-details.vue';
import OtOrganisationDetailsIndex from '@/areas/settings/organisations/ot-organisation-details-index.vue';
import OtDocumentDetails from '@/components/documents/document-details/ot-document-details.vue';
// import OtDocumentAssociations from '@/components/documents/document-associations/ot-document-associations-list.vue';
import { RouteConfig } from 'vue-router';

import OtOrganisationCalendarLayout from '@/areas/settings/calendars/ot-organisation-calendar-layout.vue';
import OtSettingsLayout from '@/areas/settings/ot-settings-layout.vue';
import { BreadcrumbsId } from '@/components/global/common-models';

// TODO one day, clean these up. They're utter tosh. Don't reckon it matters, but User Settings Org Edit what?
export const ROUTE_SETTINGS = 'Settings';
export const ROUTE_SETTINGS_USERS = 'UserSettings';
export const ROUTE_SETTINGS_CALENDARS = 'CalendarSettings';
export const ROUTE_SETTINGS_DOCUMENTS = 'DocumentsSettings';
export const ROUTE_SETTINGS_EDIT = 'EditOrganisation';
export const ROUTE_SETTINGS_ORG_USER = 'UserSettingsOrg';
export const ROUTE_SETTINGS_ORG_USER_EDIT = 'UserSettingsOrgEdit';
export const ROUTE_SETTINGS_ORG_USER_PROJECTS = 'UserSettingsOrgProjects';
export const ROUTE_SETTINGS_ORG_USER_CONTRACTS = 'UserSettingsOrgContracts';
export const ROUTE_SETTINGS_ORG_DOCUMENT = 'DocumentSettingsOrg';
export const ROUTE_SETTINGS_ORG_DOCUMENT_ASSOCIATIONS = 'DocumentSettingsOrgAssociations';

export const settingsRoutes: Array<RouteConfig> = [
  {
    path: '/settings/:orgId',
    component: OtSettingsLayout,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: '/',
        name: ROUTE_SETTINGS,
        component: OtOrganisationDetailsIndex,
        meta: {
          breadcrumb: `Settings/${BreadcrumbsId.OrganisationId}`,
        },
      },
      {
        path: 'calendars',
        name: ROUTE_SETTINGS_CALENDARS,
        component: OtSettingsCalendarIndex,
        meta: {
          breadcrumb: `Settings/${BreadcrumbsId.OrganisationId}/Calendars`,
        },
      },
      {
        path: 'users',
        name: ROUTE_SETTINGS_USERS,
        component: OtSettingsUsersIndex,
        meta: {
          breadcrumb: `Settings/${BreadcrumbsId.OrganisationId}/Users`,
        },
      },
      {
        path: 'documents',
        name: ROUTE_SETTINGS_DOCUMENTS,
        component: OtSettingsDocumentsIndex,
        meta: {
          breadcrumb: `Settings/${BreadcrumbsId.OrganisationId}/Documents`,
        },
      },
    ],
  },
  {
    path: '/settings/:orgId/edit',
    name: ROUTE_SETTINGS_EDIT,
    component: OtEditOrganisationDetails,
    meta: {
      requiresAuth: true,
      breadcrumb: `Settings/${BreadcrumbsId.OrganisationId}/Edit`,
    },
  },
  {
    path: '/settings/:orgId/users/:userGid',
    component: OtOrganisationUserLayout,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: '/',
        name: ROUTE_SETTINGS_ORG_USER,
        component: OtOrganisationUserDetails,
        meta: {
          breadcrumb: `Settings/${BreadcrumbsId.OrganisationId}/Users/${BreadcrumbsId.UserId}`,
        },
      },
      {
        path: 'projects',
        name: ROUTE_SETTINGS_ORG_USER_PROJECTS,
        component: OtOrganisationUserProjectsIndex,
        meta: {
          breadcrumb: `Settings/${BreadcrumbsId.OrganisationId}/Users/${BreadcrumbsId.UserId}/projects`,
        },
      },
      {
        path: 'contracts',
        name: ROUTE_SETTINGS_ORG_USER_CONTRACTS,
        component: OtOrganisationUserContractsIndex,
        meta: {
          breadcrumb: `Settings/${BreadcrumbsId.OrganisationId}/Users/${BreadcrumbsId.UserId}/contracts`,
        },
      },
    ],
  },
  {
    path: '/settings/:orgId/users/:userGid/edit',
    name: ROUTE_SETTINGS_ORG_USER_EDIT,
    component: OtEditOrganisationUserDetails,
    meta: {
      requiresAuth: true,
      breadcrumb: `Settings/${BreadcrumbsId.OrganisationId}/Users/${BreadcrumbsId.UserId}/Edit`,
    },
  },
  {
    path: '/settings/:orgId/documents/:documentGid',
    component: OtOrganisationDocumentLayout,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: '/',
        name: ROUTE_SETTINGS_ORG_DOCUMENT,
        // Yes, this is not org specific, it's a shared document component
        component: OtDocumentDetails,
        meta: {
          breadcrumb: `Settings/${BreadcrumbsId.OrganisationId}/Documents/${BreadcrumbsId.DocumentId}`,
        },
      },
      {
        path: 'associations',
        name: ROUTE_SETTINGS_ORG_DOCUMENT_ASSOCIATIONS,
        // normal list import doesn't work for settings. Don't know why.
        //component: OtDocumentAssociationsList,
        // wrapper import does work, but I don't like it.
        //component: OtDocumentAssociationsListWrapper,
        // this weird import works. It's like the import that we have to do sometimes in the components declarations
        component: () => import('@/components/documents/document-associations/ot-document-associations-list.vue'), //OtDocumentAssociationsListWrapper,
        meta: {
          breadcrumb: `Settings/${BreadcrumbsId.OrganisationId}/Documents/${BreadcrumbsId.DocumentId}/associations`,
        },
      },
    ],
  },

  {
    // TODO this is weird. Or the stuff above is weird, one of the two. This looks like a dupe of the
    // route for the main settings page, but it's not. We have no / route below, so this is only the calendar stuff
    // I don't like it, but it's not todays job to sort out (I'm adding the org document view today)
    path: '/settings/:orgId',
    component: OtOrganisationCalendarLayout,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: 'calendars/add',
        name: 'AddCalendar',
        component: OtAddEditOrganisationCalendar,
        meta: {
          breadcrumb: `Settings/${BreadcrumbsId.OrganisationId}/Calendars/Add`,
        },
      },
      {
        path: 'calendars/add/:calendarGid',
        name: 'DuplicateCalendar',
        component: OtAddEditOrganisationCalendar,
        meta: {
          breadcrumb: `Settings/${BreadcrumbsId.OrganisationId}/Calendars/Add/${BreadcrumbsId.CalendarId}`,
        },
      },
      {
        path: 'calendars/:calendarGid',
        name: 'ViewCalendar',
        component: OtOrganisationCalendarDetails,
        meta: {
          breadcrumb: `Settings/${BreadcrumbsId.OrganisationId}/Calendars/${BreadcrumbsId.CalendarId}`,
        },
      },
      {
        path: 'calendars/:calendarGid/edit',
        name: 'EditCalendar',
        component: OtAddEditOrganisationCalendar,
        meta: {
          breadcrumb: `Settings/${BreadcrumbsId.OrganisationId}/Calendars/${BreadcrumbsId.CalendarId}/Edit`,
        },
      },
    ],
  },
];
